import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { router } from "./router";
import "./index.css";

// #583: Prevent white screen when back-navigating past SPA history origin.
// If the user presses Back beyond the first SPA route, the browser would go
// to about:blank. We push an extra history entry and redirect to /topics.
if (window.history.length <= 1) {
  window.history.replaceState(null, "", window.location.href);
}
window.addEventListener("popstate", () => {
  // about:blank or empty pathname means we've left the SPA
  if (!window.location.pathname || window.location.pathname === "/") {
    // Already handled by router index redirect, no extra action needed
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  </StrictMode>,
);
